import { Grid, Typography } from '@mui/material';
import ArrowRight from 'assets/icons/buttons/chevron-right.svg';
import DraftIcon from 'assets/icons/buttons/draft-edit.svg';
import { IDraftButton } from './types';
import { styles } from './styles';

export const DraftButton = ({ draftsCount, onClick }: IDraftButton) => {
  const typo = `${draftsCount} draft${draftsCount > 1 ? 's' : ''}`;

  return (
    <Grid sx={styles.container} onClick={onClick}>
      <DraftIcon style={styles.draftIcon} />
      <Grid sx={styles.divider} />
      <Typography sx={styles.typo}>{typo}</Typography>
      <ArrowRight style={styles.arrowRightIcon} />
    </Grid>
  );
};
